export default {"src":"/_next/static/media/core.3b810e08.svg","height":378,"width":630,"blurWidth":0,"blurHeight":0};